import { useState } from 'react'
import { message as $message } from 'antd'

import { queryMySupplierCount, queryMyChannelCount } from '@/services/afterSale'

interface useCoopChannelSupplierReturn {
    hasCoopChannel?: Boolean
    hasCoopSupplier?: Boolean
    init: Function
}

export default (): useCoopChannelSupplierReturn => {
    const [hasCoopChannel, setHasCoopChannel] = useState(undefined)
    const [hasCoopSupplier, setHasCoopSupplier] = useState(undefined)

    const initSupplierCount = async () => {
        try {
            const { success, data, message } = await queryMySupplierCount({ distributorStatusEnum: 'Confirmed' })
            if (success) {
                setHasCoopSupplier(!!data)
            } else {
                $message.error(message)
            }
        } catch (error) {
            console.error('catchError', error)
        }
    }

    const initChannelCount = async () => {
        try {
            const { success, data, message } = await queryMyChannelCount({ distributorStatusEnum: 'Confirmed' })
            if (success) {
                setHasCoopChannel(!!data)
            } else {
                $message.error(message)
            }
        } catch (error) {
            console.error('catchError', error)
        }
    }
    const init = () => {
        if (hasCoopChannel === undefined) {
            initChannelCount()
        }
        if (hasCoopSupplier === undefined) {
            initSupplierCount()
        }
    }

    return {
        hasCoopChannel,
        hasCoopSupplier,
        init
    }
}
